module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"inbox":"Inbox","lock":"Lock","logout":"Log out"},"sl":{"inbox":"Prejeto","lock":"Zakleni","logout":"Odjava"}}')
  delete Component.options._Ctor
}
